// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("../channels")

// Import jQuery and Bootstrap dependencies
import 'jquery'
import 'popper.js'
import 'bootstrap'

// Load Bootstrap CSS through stylesheet_pack_tag
// The CSS will be handled by MiniCssExtractPlugin, not imported directly
// import 'bootstrap/dist/css/bootstrap.min.css'

// Import application styles
import '../stylesheets/application.scss'

// Import custom JavaScript
import '../src/custom'
import '../src/typeahead-helper'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// This will be your new JavaScript entry point
console.log('Webpacker loaded!')

// Initialize Bootstrap components when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded');
  
  // Initialize tooltips
  $('[data-toggle="tooltip"]').tooltip()
  
  // Initialize popovers
  $('[data-toggle="popover"]').popover()
  
  // Force-load Bootstrap CSS if not already loaded
  setTimeout(function() {
    // Check if Bootstrap is already loaded
    const hasBootstrap = document.querySelector('link[href*="bootstrap"]');
    
    if (!hasBootstrap) {
      console.log('Bootstrap CSS not detected, loading from CDN');
      const bootstrapLink = document.createElement('link');
      bootstrapLink.rel = 'stylesheet';
      bootstrapLink.href = 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css';
      bootstrapLink.integrity = 'sha384-B0vP5xmATw1+K9KRQjQERJvTumQW0nPEzvF6L/Z6nronJ3oUOFUFpCjEUQouq2+l';
      bootstrapLink.crossOrigin = 'anonymous';
      document.head.appendChild(bootstrapLink);
    }
    
    // Add direct styles for critical elements if styling seems absent
    const body = document.body;
    if (window.getComputedStyle(body).backgroundColor === 'rgba(0, 0, 0, 0)' || 
        window.getComputedStyle(body).backgroundColor === 'transparent') {
      console.log('Adding emergency CSS styles');
      
      const criticalStyles = document.createElement('style');
      criticalStyles.textContent = `
        body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
        .navbar { z-index: 3; }
        .btn-primary { color: #fff; background-color: #CA0000; border-color: #AB0505; }
        .btn-primary:hover { background-color: #AB0505; border-color: #950505; }
        footer { background-color: #f8f9fa; padding: 20px 0; margin-top: 20px; }
        .jumbotron { padding: 4rem 2rem; margin-bottom: 2rem; background-color: #e9ecef; border-radius: 0.3rem; }
      `;
      document.head.appendChild(criticalStyles);
    }
  }, 300);
}) 